module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/Display2-0aaa0d68f2cd99a46caa021a81ffb0c4.svg";